export const APP_PUBLIC_POSTHOG_KEY = "phc_dvKQVDqigL2WBlu3k7xyOMSFzwV588kB85VnY8MoGSs";
export const APP_PUBLIC_POSTHOG_HOST = "https://eu.i.posthog.com";
